import React, { useState, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useDropzone } from 'react-dropzone';
import useApiFetch from '../ApiFetch.js';
import { BlobServiceClient } from '@azure/storage-blob';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


//import axios from 'axios';

const uniqueId = uuidv4();

export default function DropZoneAzure(props) {

    //const [objectKey, setObjectKey] = useState('');
    //const [imageURL, setImageURL] = useState('');
    //const [imageFileType, setImageFileType] = useState('');

    //const [selectedFile, setSelectedFile] = useState(null);

    const [file, setFile] = useState(null);
    const apiFetch = useApiFetch();

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const onDrop = useCallback(acceptedFiles => {
        setFile(acceptedFiles[0]);
        if (acceptedFiles[0]) {
            handleUpload(acceptedFiles[0]);
        }
        console.log("Azure Dropped");
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });


    const handleUpload = async (theFile) => {
        if (file) {
            theFile = file;
        }
        if (theFile) {
            // 1. Get SAS token from your .NET backend
            //https://localhost:44427/api/sastoken/generatesastoken?blobName=ufaf_circuit_logo.png
            //const sasTokenResponse = await fetch('/api/sastoken/generate?blobName=' + file.name, {
            const blobName = uniqueId + '.' + theFile.name;

            const sasTokenResponse = await apiFetch.get('/api/sastoken/generatesastokenurl?blobname=' + encodeURIComponent(blobName));
            const sasTokenUrl = await sasTokenResponse.data;
            
            // 2. Upload the file using the SAS token
            const blobServiceClient = new BlobServiceClient(sasTokenUrl);

            const containerClient = blobServiceClient.getContainerClient('listings');
            const blockBlobClient = containerClient.getBlockBlobClient(blobName);

            await blockBlobClient.uploadData(theFile);

            //assuming that it is all good
            if (props.fileUploaded)
                props.fileUploaded(blobName);
            setFile(null);
        }
    }


    return (
        <>
            <div {...getRootProps()}
                style={{
                    border: '2px',
                    padding: '14px',
                    borderRadius: 8,
                    borderColor: '#eeeeee',
                    borderStyle: 'dashed',
                    backgroundColor: '#fafafa',
                    color: '#bdbdbd',
                    fontSize: '.90em',
                }}>
                <input type="file" {...getInputProps()} />
                {isDragActive ? (
                    <p>Drop the file here ...</p>
                ) : (
                    <>
                            <p>Drag and drop tournament image</p>
                            {file && <>Uploading Image... <FontAwesomeIcon icon={faSpinner} spin /></>}
                    </>
                )}

            </div>
        </>
    );
};


/*
const options = {
  params: { Key: file.name, ContentType: file.type },
  headers: { 'Content-Type': file.type }
};
*/


//const [selectedFile, setSelectedFile] = useState(null);

//   const handleFileChange = (event) => {
//     setSelectedFile(event.target.files[0]);
//   };

//   const handleUpload = async () => {
//     if (!selectedFile) return;

//     try {
//       const { data } = await axios.post('/generate-presigned-url', {
//         fileName: selectedFile.name,
//         fileType: selectedFile.type
//       });

//       await axios.put(data.url, selectedFile, {
//         headers: {
//           'Content-Type': selectedFile.type
//         }
//       });

//       console.log('File uploaded successfully!');
//     } catch (error) {
//       console.error('Error uploading file:', error);
//     }
//   };





//   const getPresignedURL = async (fileName) => {

//     console.log({fileName});

//     await fetch('/api/imageurl/index?objectKey='+ `${fileName}`)
//               .then( async(resp) => { 

//                 const response = (await resp.text());
//                 const responseString = response.toString().replaceAll('"', '');

//                 setImageURL(responseString);

//                 console.log(imageURL);

//     })
//     .catch((ex) => {
//         console.error(ex);
//     })
//     .finally(() => {
//     });


//     await axios.put(imageURL, selectedFile, {
//       headers: {
//         'Content-Type': imageFileType
//       }
//     });
//   }

//   /*
//   const {
//     acceptedFiles,
//     fileRejections,
//     getRootProps,
//     getInputProps,
//   } = useDropzone({
//     maxFiles:1,
//     accept: {
//       'image/jpeg': [],
//       'image/jpg': [],
//       'image/png': []
//     }
//   });


//   const acceptedFileItems = acceptedFiles.map(file => (
//     <li key={file.path}>
//       {file.name} - {file.size} bytes
//      {HandleDropFile(file)}



//     </li>
//   ));
//   */

//   /*
//   const fileRejectionItems = fileRejections.map(({ file, errors }) => (
//     <li key={file.path}>
//       {file.path} - {file.size} bytes
//       <ul>
//         {errors.map(e => (
//           <li key={e.code}>{e.message}</li>
//         ))}
//       </ul>
//     </li>
//   ));

//   */

//   //const [files, setFiles] = useState([]);


//   const handleDrop = (e) => {
//     e.preventDefault();
//     console.log(e.dataTransfer.files);

//     //handleFileName();
//     setSelectedFile(e.dataTransfer.files[0]);
//     setObjectKey(e.dataTransfer.files[0].name);
//     setImageFileType(e.dataTransfer.files[0].type);
//     getPresignedURL(e.dataTransfer.files[0].name);

//     handleUpload();
//     //console.log(imageURL);

//     //console.log(droppedFiles);
//     //setFiles([...files, ...droppedFiles]);
//   };

//   const handleDragOver = (e) => {
//     e.preventDefault();
//   };

//   return (
//     <div
//       onDrop={onDrop}
//       onDragOver={handleDragOver}
//       style={{  border: '2px', 
//                 padding: '20px',
//                 borderRadius: 8,
//                 borderColor: '#eeeeee',
//                 borderStyle: 'dashed',
//                 backgroundColor: '#fafafa',
//                 color: '#bdbdbd',
//                 fontSize: '.90em',
//           }}
//     >
//       <p>Drag and drop tournament image here</p>
//       {/*<ul>
//         {files.map((file, index) => (
//           <li key={index}>{file.name}
//           </li>
//         ))}
//       </ul>*/}
//       <span style={{ fontSize: "0.7em"}}>
//           <p>{objectKey}</p>
//           <p>{imageURL}</p>
//           <p>{uniqueId}</p>
//       </span>

//       <input 
//       type="hidden" 
//       name="listingFileName"
//       value={objectKey}

//       />

//       <input 
//       type="hidden" 
//       name="listingPresignedImageURL"
//       value={imageURL}


//       />

//       </div>



//   );

//   /* return (
//     <section className="container border-1">
//       <div {...getRootProps({
//       style: baseStyle, className: 'dropzone',

//       //onDrop: {HandleDropFile}
//       //onDrop: HandleDropFile(file),
//       //onDrop: event => event.stopPropagation() // Prevent event bubbling
//     })}>

//       {/*</div>
//       <div {...getRootProps({ style: baseStyle, className: 'dropzone' })}>}

//         <input {...getInputProps()} onChange={(file) => HandleDropFile(file) } onDrop={HandleDropFile}

//         />

//         <p>Drag & drop tournament image here, or click to select files</p>
//         <em>(Only .jpeg, .jpg and .png images will be accepted)</em>
//       </div>
//       <aside>
//         <h6 style={{ color: "#bababa", fontSize: ".80em" }}>Accepted files</h6>
//         <ul>{acceptedFileItems}</ul>
//         <ul>{imageURL}</ul>
//       </aside>
//     </section>
//   ); */
// }

/*<DropZoneAzure />*/
